<template>
  <Modal :visible="visible" @close="close()">
    <h2 class="sources-count">{{ getPublishers.length }} sources for this story</h2>

    <div class="publisher-stack">
      <div v-for="(publisher, idx) in getPublishers" :key="idx" class="publisher" @click="openPublisher(publisher)">
        <img :src="publisher.icon" :alt="publisher.name">
        
        <div class="publisher-meta">
          <span class="article-heading">{{ publisher.article ? publisher.article.name : '' }}</span>
          <span class="article-date">{{ getPublishDate(publisher.article) }}</span>
        </div>

        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.93417 0.464775C8.8581 0.281602 8.71254 0.13604 8.52936 0.059971C8.43924 0.0215588 8.34246 0.00118442 8.2445 0H0.748125C0.549309 0 0.358636 0.0789796 0.218051 0.219564C0.0774669 0.360148 -0.00151272 0.550821 -0.00151272 0.749638C-0.00151272 0.948454 0.0774669 1.13913 0.218051 1.27971C0.358636 1.4203 0.549309 1.49928 0.748125 1.49928H6.43788L0.215882 7.71377C0.14562 7.78346 0.0898513 7.86637 0.0517931 7.95772C0.013735 8.04907 -0.00585938 8.14705 -0.00585938 8.24602C-0.00585938 8.34498 0.013735 8.44296 0.0517931 8.53431C0.0898513 8.62566 0.14562 8.70857 0.215882 8.77826C0.285571 8.84852 0.368481 8.90429 0.459832 8.94235C0.551182 8.98041 0.649164 9 0.748125 9C0.847086 9 0.945068 8.98041 1.03642 8.94235C1.12777 8.90429 1.21068 8.84852 1.28037 8.77826L7.49487 2.55626V8.24602C7.49487 8.44483 7.57384 8.63551 7.71443 8.77609C7.85501 8.91667 8.04569 8.99565 8.2445 8.99565C8.44332 8.99565 8.63399 8.91667 8.77458 8.77609C8.91516 8.63551 8.99414 8.44483 8.99414 8.24602V0.749638C8.99296 0.651677 8.97258 0.554899 8.93417 0.464775Z" fill="#16191C"/>
        </svg>
      </div>
    </div>
  </Modal>
</template>

<script>
  import dayjs from 'dayjs'
  import relativeTime from 'dayjs/plugin/relativeTime'
  dayjs.extend(relativeTime)
  import Modal from 'app/components/_v6/modal/base/Modal.vue' 

  export default {
    data() {
      return {
        visible: false,
        publishers: {
          type: Array,
          default: [],
        },
      }
    },

    components: {
      Modal,
    },

    computed: {
      getPublishers() {
        return this.publishers || [];
      },
    },

    mounted () {
      this.EventBus.$on('modal:publishers', (publishers) => {
        this.visible = true;
        this.publishers = publishers.publishers;
      });
    },

    methods: {
      openPublisher(publisher) {
        this.EventBus.$emit("didSelectArticle", {
          src: this,
          article: publisher.article,
          story: '-',
        });
      },

      getPublishDate(article) {
        let date = article?.published || '';
        let timeAgo = dayjs(date);
        let difference = timeAgo.from(dayjs(), 'y')

        if (difference < 0) {
          return 'Unknown'
        } else {
          return timeAgo.fromNow();
        }
      },

      close() {
        this.visible = false;
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/__2020_v3.scss';

  .sources-count {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 1rem;
  }

  .publisher-stack {
    .publisher {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      padding: 1rem;
      background: rgba($neutral-500, 0.5);
      border-radius: 5px;
      cursor: pointer;

      .darkmode & {
        background: rgba($neutral-300, 0.5);
      }

      &:not(:last-child) {
        margin-bottom: 0.75rem;
      }

      img { 
        width: 24px;
        height: 24px;
        border-radius: 500px;
      }

      .publisher-meta {
        display: flex;
        flex-direction: column;
        margin: 0 1rem 0 0.75rem;
        flex: 1;

        .article-heading {
          font-weight: bold;
          margin-bottom: 0.25rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical
        }

        .article-date {
          color: $neutral-400;
        }
      }

      .darkmode & {
        svg path {
          fill: $neutral-600;
        }
      }
    }
  }
</style>